import { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Clock, Tag, User } from "lucide-react";
import "./HomePage.css";
import { htmlSafe } from "../lib/sanitize";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BASE = process.env.REACT_APP_BACKEND_URL;

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    axios.get(`${API}/public/blog/${slug}`)
      .then((r) => { setPost(r.data); setLoading(false); })
      .catch(() => { setLoading(false); });
  }, [slug]);

  useEffect(() => {
    if (post) {
      document.title = post.seo_title || `${post.title} — Prepify`;
    }
    return () => { document.title = "Prepify"; };
  }, [post]);

  if (loading) return <div className="prepify-v2"><div style={{ padding: 200, textAlign: "center", color: "var(--ink-4)" }}>Loading…</div></div>;
  if (!post) return (
    <div className="prepify-v2">
      <div style={{ padding: "200px 24px", textAlign: "center" }}>
        <h1 className="sec-title">Post not found</h1>
        <Link to="/blog" className="btn-pill-primary" style={{ marginTop: 20 }}>Back to blog</Link>
      </div>
    </div>
  );

  return (
    <div className="prepify-v2">
      <nav className="nav-pill">
        <div className="nav-pill-inner">
          <Link to="/" className="nav-logo"><span className="nav-logo-dot" />prepify</Link>
          <div className="nav-links">
            <Link to="/#services"><button>Services</button></Link>
            <Link to="/#journey"><button>Journey</button></Link>
            <Link to="/blog"><button>Blog</button></Link>
            <Link to="/#pricing"><button>Pricing</button></Link>
          </div>
          <div className="nav-actions">
            <Link to="/login" className="nav-login">Staff Login</Link>
            <Link to="/#contact" className="btn-pill-primary nav-cta">Partner with us</Link>
          </div>
        </div>
      </nav>

      <article style={{ padding: "140px 24px 80px", maxWidth: 820, margin: "0 auto" }}>
        <button onClick={() => nav(-1)} style={{ background: "none", border: "none", color: "var(--ink-4)", fontSize: 14, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6, marginBottom: 32 }}>
          <ArrowLeft size={14} /> Back
        </button>
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 16, fontSize: 13, color: "var(--ink-4)", marginBottom: 20 }}>
          {post.category && <span className="chip">{post.category}</span>}
          {post.published_at && <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><Clock size={13} /> {new Date(post.published_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}</span>}
          {post.author_name && <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><User size={13} /> {post.author_name}</span>}
        </div>
        <h1 className="sec-title" style={{ fontSize: "clamp(2rem, 5vw, 3.5rem)", textAlign: "left", marginBottom: 24 }}>{post.title}</h1>
        {post.excerpt && <p style={{ fontSize: "1.25rem", color: "var(--ink-3)", lineHeight: 1.6, marginBottom: 32, fontWeight: 500 }}>{post.excerpt}</p>}
        {post.cover_image_url && (
          <img src={post.cover_image_url.startsWith("/") ? `${BASE}${post.cover_image_url}` : post.cover_image_url} alt={post.title} style={{ width: "100%", borderRadius: 24, margin: "24px 0 40px", border: "1px solid var(--line)" }} />
        )}
        <div style={{ fontSize: "1.0625rem", lineHeight: 1.8, color: "var(--ink-2)" }} dangerouslySetInnerHTML={htmlSafe(post.content_html)} />
        {post.tags && post.tags.length > 0 && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 48, paddingTop: 24, borderTop: "1px solid var(--line)" }}>
            {post.tags.map((t) => <span key={t} className="chip"><Tag size={11} /> {t}</span>)}
          </div>
        )}
      </article>
    </div>
  );
};

export default BlogPost;
